import PropTypes from 'prop-types';

export const DropdownMenuType = {
  ComboBox: 'ComboBox',
  Menu: 'Menu',
};

export const DropdownMenuTypePropType = PropTypes.oneOf(Object.values(DropdownMenuType));
